import BaseTable from 'components/Tables/BaseTable';
import { actions as productActions } from 'ducks/products';
import { actions as productRMActions } from 'ducks/productRawMaterials';
import { actions as rawMaterialsActions } from 'ducks/rawMaterials';
import { actions as actionsRawMatSuppliers } from 'ducks/rawMaterialSuppliers';
import { sortBy } from 'lodash';
import ShipmentInserterTable from 'pages/Products/ProductRM/shipmentInserterTable';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { filterByFieldSelector, groupBy, shipmentsByRawMaterial } from 'selectors/generic';
import theme from 'source/theme';
import { MIXTURE, POLIMER, SUBSTANCE } from 'utils/constants/coreConstants';
import { DISTRIBUIDOR, FABRICANTE, UJ } from 'utils/constants/reach_role';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/product/productOutRawMaterial';
import { currentUser } from 'selectors/currentUser';

// `product.product_raw_materials` read from either end: by product, and - for
// deleteShipmentOfRM below - by raw material, which is what `rm.products` was.
const compositionByProduct = groupBy('productRawMaterials', 'product_id');
const compositionByRawMaterial = groupBy('productRawMaterials', 'raw_material_id');

const Component = props => {
    let {
        composition, compositionOf, highlightSubstances, inOutFinalRM, productId,
        productsById, rawMaterials, rawMaterialsById, shipmentsOf, title, user
    } = props;
    const {
        createProductRM, fetchProduct, fetchRawMaterial, handleCloseDrawer,
        handleOpenRmInserter, removeProductRM, removeRawMatSupplier, setHighlightSubstances,
        updateRawMaterial
    } = props;

    const tableRef = useRef(null);

    const [selectedIds, setSelectedIds] = useState([]);
    const [loading, setLoading] = useState(false);

    const [RMShipmentInsert, setRMShipmentInsert] = useState(null);
    const [posShipmentInsertRequest, setPosShipmentInsertRequest] = useState(null);
    const handleCloseShipmentInserter = () => {
        setLoading(false);
        setPosShipmentInsertRequest(null);
    };

    useEffect(() => {
        const tempSelectedIds = [];

        (composition[productId] || []).forEach(prm => {
            if (!prm.added_to_charge && prm.mixture_id === null) {
                tempSelectedIds.push(prm.raw_material_id);
            }
        });

        setSelectedIds(tempSelectedIds);

    }, [productsById, rawMaterials]);
    
    rawMaterials = rawMaterials.map(subst => {
        if (selectedIds.includes(subst.id)) {
            return { ...subst, tableData: { checked: true } };
        } else {
            return { ...subst, tableData: { checked: false } };
        }
    });

    const orderedSubstances = sortBy(rawMaterials, [row => !selectedIds.includes(row.id), 'id']);

    /**
     * return true if no shipment is found for MP as FABRICANTE or DISTRIBUIDOR. If any is detected
     * returns false. No need to create new shipment as FABRICANTE or DISTRIBUIDOR
     */
    const createShipmentForRM = (rm, productType) => {
        const shipments = shipmentsOf[rm.id] || [];
        if (shipments.length === 0) {
            return true;
        } else if (productType === 'out') {
            const notProduced = shipments.map(s => s.reach_role !== FABRICANTE).every(t => t);
            if (notProduced) {
                return true;
            }
        } else if (productType === 'distr') {
            const notDistributed = shipments.map(s => s.reach_role !== DISTRIBUIDOR).every(t => t);
            if (notDistributed) {
                return true;
            }
        }
        return false;
    };

    /**
     * return true if length of the array with all product_MP where MP is FABRICANTE  is 1.
     * If more than 1 product_MP as FABRICANTE  shipment shouldn't be deleted
     * ONLY EXISTS FOR FABRICANTE BECAUSE THERE IS ONLY ONE SHIPMENT FABRICANTE
     */
    const deleteShipmentOfRM = (pId, rm) => {
        // TODO this is here because API repeats the product everytime the RM is
        // inserted in the product CARGA or REACÇÃO
        const productsSet = new Set((compositionOf[rm.id] || []).map(prm => prm.product_id));
        const products = Array.from(productsSet);

        const productRawMaterialssToCheck = products
            .reduce((acc, id) => [...acc, ...(composition[id] || [])], []);

        const rmProducedOnProduct = productRawMaterialssToCheck
            .filter(prm => (prm.raw_material_id === rm.id) && !prm.added_to_charge && !prm.mixture_id);
        return rmProducedOnProduct.length === 1;
    };

    const OutRawMaterialSelectorTable = () => (
        <BaseTable
            ref={tableRef}
            titleBack={true}
            titleAction={handleCloseDrawer}
            title={title}
            onRowClick={() => null}
            onRowDoubleClick={rowData => setHighlightSubstances([rowData.id])}
            columns={columns(user)}
            data={orderedSubstances}
            order={false}
            options={{
                selection: true,
                showTextRowsSelected: false,
                showSelectAllCheckbox: false,
                rowStyle: rowData => ({
                    backgroundColor: highlightSubstances.includes(rowData.id) && rowData.tableData.checked ?
                        theme.palette.primary.light : ''
                })
            }}
            isLoading={loading}
            onSelectionChange={(rows, difRow) => {
                const rowIds = rows.map(row => row.id);

				            // https://stackoverflow.com/a/33034768 - Symmetric Difference
				            const intersection = rowIds
						            .filter(x => !selectedIds.includes(x))
						            .concat(selectedIds.filter(x => !rowIds.includes(x)));

				            if (intersection.length !== 1) {
						            alert('bug detected, please contact support');
						            return;
				            }

                setLoading(true);
                if (rows.length > selectedIds.length) {
                    const filteredProductRM = (composition[productId] || [])
                        .filter(pMP => rawMaterialsById[pMP.raw_material_id].type !== MIXTURE);
                    const preExistentMP = filteredProductRM.find(pMP => pMP.raw_material_id === difRow.id);

                    // TODO Not clear why when passing a promise as parameter through useState
                    // TODO Usetate executes a level of the function
                    const productRMCreate = () => () =>
                        createProductRM({
                            product_id: productId,
                            raw_material_id: difRow.id,
                            raw_material_final: true,
                            added_to_charge: false,
                            excluded_from_final_product: preExistentMP ?
                                preExistentMP.excluded_from_final_product : false,
                            contributes_to_hazard: preExistentMP ? preExistentMP.contributes_to_hazard : inOutFinalRM === 'distr'
                        })
                            .then(() => fetchRawMaterial(difRow.id))
                            .then(() => fetchProduct(productId))
                            .catch(e => alert(e))
                            .finally(() => setLoading(false));

                    setRMShipmentInsert(difRow);
                    //TODO send CLOSE to SHIPMENT dialog box
                    setPosShipmentInsertRequest(productRMCreate);

                } else {
                    const substanceToRemove = (composition[productId] || [])
                        .find(prm => (prm.raw_material_id === difRow.id) && !prm.added_to_charge && !prm.mixture_id);
                    removeProductRM(substanceToRemove.id)
                        .then(() => fetchRawMaterial(difRow.id))
                        .then(() => fetchProduct(productId))
                        .catch(e => alert(e))
                        .finally(() => setLoading(false));
                }
            }}
            actions={[
                {
                    icon: tableIcons.AddSubstancePolimer,
                    tooltip: 'Adicionar Substância ou Polímero',
                    onClick: () => handleOpenRmInserter(),
                    position: 'toolbar'
                },
                {
                    icon: tableIcons.AddSubstancePolimer,
                    tooltip: 'Adicionar Substância ou Polímero',
                    onClick: () => handleOpenRmInserter(),
                    position: 'toolbarOnSelect'
                }
            ]}
        />
    );

    return (
        <React.Fragment>
            <OutRawMaterialSelectorTable/>
            {
                posShipmentInsertRequest &&
                <ShipmentInserterTable
                    fullSize={true}
                    rawMaterial={RMShipmentInsert}
                    postInsertRequest={posShipmentInsertRequest}
                    closeParentContainer={handleCloseShipmentInserter}
                    shipmentType={
                        productsById[productId].reach_role === UJ ?
                            FABRICANTE :
                            productsById[productId].reach_role
                    }
                />

            }
        </React.Fragment>
    );
};

const makeMapStateToProps = () => {
    const rawMaterials = filterByFieldSelector('rawMaterials', 'type', [SUBSTANCE, POLIMER]);
    const mapStateToProps = (state, props) => ({
        composition: compositionByProduct(state),
        compositionOf: compositionByRawMaterial(state),
        rawMaterials: rawMaterials(state),
        rawMaterialsById: state.rawMaterials.models,
        productsById: state.products.models,
        shipmentsOf: shipmentsByRawMaterial(state),
        user: currentUser(state)
    });
    return mapStateToProps;
};


const mapDispatchToProps = dispatch => ({
    fetchProduct: id => dispatch(productActions.fetchOne(id)),
    fetchRawMaterial: id => dispatch(rawMaterialsActions.fetchOne(id)),
    updateRawMaterial: (id, data) => dispatch(rawMaterialsActions.updatePromise(id, data)),
    createProductRM: data => dispatch(productRMActions.createPromise(data)),
    removeProductRM: id => dispatch(productRMActions.removePromise(id)),
    removeRawMatSupplier: id => dispatch(actionsRawMatSuppliers.removePromise(id))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
